import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { mergeStyleSets, Text } from '@fluentui/react';
import { SubmittedModal } from '@shared/components/modals/submittedModal';
import { NeutralColors, SharedColors } from '@fluentui/theme';
import { ExternalLink } from '@shared/components/externalLink';
const externalUrl = (correlationId)=>`https://aka.ms/appsource/comscore?correlationID=${correlationId}`;
const subTextStyles = {
    root: {
        color: NeutralColors.gray130,
        lineHeight: 20
    }
};
const classNames = mergeStyleSets({
    externalLink: [
        {
            display: 'inline-block',
            color: `${SharedColors.cyanBlue10} !important`
        }
    ]
});
export const NpsSubmittedModal = ({ hidden, onDismiss, correlationId, context })=>{
    return /*#__PURE__*/ _jsxs(SubmittedModal, {
        hidden: hidden,
        onDismiss: onDismiss,
        title: context.loc('Nps_SubmittedModal_Title', 'Feedback received'),
        context: context,
        children: [
            /*#__PURE__*/ _jsx(Text, {
                block: true,
                styles: subTextStyles,
                children: context.loc('Nps_SubmittedModal_Summary_Text', 'Thanks for taking the time to share your thoughts!')
            }),
            /*#__PURE__*/ _jsx(Text, {
                styles: subTextStyles,
                children: `${context.loc('Nps_SubmittedModal_Link_Invitation_Text', 'If you’d like to help us even more')}, `
            }),
            /*#__PURE__*/ _jsx(ExternalLink, {
                className: classNames.externalLink,
                accessibilityEnabled: true,
                href: externalUrl(correlationId),
                target: "_blank",
                rel: "noreferrer",
                onClickHandle: onDismiss,
                children: context.loc('Nps_SubmittedModal_External_Link_Text', 'take our online survey')
            }),
            /*#__PURE__*/ _jsx(Text, {
                styles: subTextStyles,
                children: "."
            })
        ]
    });
};
